import { platformContextService } from '../platformContext/PlatformContextService';
import { PlatformEnum } from '../platformContext/platformContextTypes';

import type { LifecycleEventData, NoDataEventNames, DataEventNames } from './lifecycleEventEmitterTypes';

class LifecycleEventEmitterService {
  private get platform() {
    return platformContextService.getConfig().platform;
  }

  public emitMessage<T extends NoDataEventNames>(type: T): void;
  public emitMessage<T extends DataEventNames>(type: T, payload: LifecycleEventData[T]): void;
  public emitMessage<T extends keyof LifecycleEventData>(type: T, payload?: LifecycleEventData[T]): void {
    const reactNativeWebView = window.webkit?.messageHandlers?.ReactNativeWebView || window.ReactNativeWebView;
    if (reactNativeWebView && this.platform !== PlatformEnum.WEB) {
      reactNativeWebView.postMessage(JSON.stringify({ type, payload }));
    } else {
      window.parent.postMessage({ type, payload }, '*');
    }
  }
}

export const lifecycleEventEmitterService = new LifecycleEventEmitterService();
